import { SiteShell } from "@shared/ui/SiteShell"
import { createFileRoute } from "@tanstack/react-router"
import { ErrorPage } from "./-ErrorPage"

export const Route = createFileRoute("/404")({
  component: () => (
    <SiteShell page="error404">
      <ErrorPage />
    </SiteShell>
  ),
})
